import { render, staticRenderFns } from "./TransitionSlideUpDown.vue?vue&type=template&id=8d56594e&scoped=true&"
import script from "./TransitionSlideUpDown.vue?vue&type=script&lang=js&"
export * from "./TransitionSlideUpDown.vue?vue&type=script&lang=js&"
import style0 from "./TransitionSlideUpDown.vue?vue&type=style&index=0&id=8d56594e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d56594e",
  null
  
)

export default component.exports